module.exports = __webpack_public_path__ + "img/8.66056a4f.svg";